import Axios from '@/api/http'

/**
 * 获取小铃铛列表
 * */
export function openapiGetusermessagelist (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getusermessagelist',
    data: query,
  })
}

/**
 * 小红点提示条数
 * */
export function openapiGetunreadmessagecount (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getunreadmessagecount',
    data: query,
  })
}

/**
 * 提示消息状态变成已读
 * */
export function openapiUpdateusermessage (query) {
  return Axios({
    method: 'post',
    url: '/openapi/updateusermessage',
    data: query,
  })
}

/*
* 添加默认门户
*/

export function adddefaultdesk (query) {
  return Axios({
    method: 'post',
    url: '/openapi/adddefaultdesk',
    data: query,
  })
}
/*
* 添加默认空间门户
*/

export function addspacedefaultdesk (query) {
  return Axios({
    method: 'post',
    url: '/openapi/addspacedefaultdesk',
    data: query,
  })
}
/*
* 全部标记已读
*/

export function batchusermessageread (query) {
  return Axios({
    method: 'post',
    url: '/openapi/batchusermessageread',
    data: query,
  })
}
